
import { defineComponent } from "vue";
import EventBusService from "@/services/EventBusService";
import { RecordIdentifier } from "@/data/global";
import { Course } from "@/data/course";
import { CourseDetailsOpenEvent } from "@/data/eventbus";
import CourseEnrollmentModal from "@/components/modals/CourseEnrollmentModal.vue";

declare interface CourseEnrollmentModalGlobalInjectorData {
    modalShown: boolean,
    course: Course|RecordIdentifier|null, // @TODO: we actually do not load the course record, so maybe do not allow RecordIdentifier?
    closeOnEnrollmentChange: boolean,
}

export default defineComponent({
    name: 'CourseEnrollmentModalGlobalInjector',
    components: {
        CourseEnrollmentModal,
    },
    props: {

    },
    computed: {

    },
    data() : CourseEnrollmentModalGlobalInjectorData {
        return {
            modalShown: false,
            course: null,
            closeOnEnrollmentChange: false,
        };
    },
    methods: {
        openModal(event: CourseDetailsOpenEvent) {
            this.course = event.course;
            this.modalShown = true;
            this.closeOnEnrollmentChange = event?.closeOnEnrollmentChange || false;
        },
        onEnrollmentStatusChange() {
            if( this.closeOnEnrollmentChange ) {
                this.modalShown = false;
            }
        },
    },
    watch: {

    },
    mounted() {
        EventBusService.$on('modals.course.details.open', this.openModal);
    },
    beforeUnmount() {
        EventBusService.$off('modals.course.details.open', this.openModal);
    }
});
